import * as Mui from "@mui/material";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import CarSegmentInfoType from "../../../types/CarSegmentInfoType";
import FormInput from "../../common/FormInput";

interface Props {
  carSegmentInfo?: CarSegmentInfoType[];
}

export const CarSegmentInfoDetails = (props: Props) => {
  const t = useOperationTranslation();
  return (
    <>
      {props.carSegmentInfo?.map((carSegmentInfo, index) => {
        return (
          <Mui.Box key={`carSegmentInfo-box-${index}`} mb={2}>
            <Mui.Card key={`carSegmentInfo-card-${index}`}>
              <Mui.CardContent key={`carSegmentInfo-card-content-${index}`}>
                <Mui.Grid
                  container
                  key={`carSegmentInfo-grid-content-${index}`}
                  columns={12}
                  alignItems="center"
                  spacing={2.5}
                  rowGap={4}
                >
                  {/*--------------------------------------- 1 row --------------------------------*/}

                  <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <FormInput
                      name="description"
                      label={t(
                        "deliveryNote.deliveryDetails.tab.carSegmentInfo.carSegmentId"
                      )}
                      value={carSegmentInfo?.description || ""}
                      type="text"
                      disabled
                      fullWidth
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <FormInput
                      name="vehiclesNum"
                      label={t(
                        "deliveryNote.deliveryDetails.tab.carSegmentInfo.vehiclesNum"
                      )}
                      value={carSegmentInfo?.vehiclesNum || ""}
                      type="text"
                      disabled
                      fullWidth
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.CardContent>
            </Mui.Card>
          </Mui.Box>
        );
      })}
    </>
  );
};
